import React, { useState } from 'react';

import { Alert, Box, Button, Stack } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TableHeaderCustomEvolucao from '@/components/Base/TableHeaderCustomEvolucao';
import { TitlePages } from '@/components/Base/TitlePage';
import { useConsolidationEvolutionAdvanced } from '@/features/dashboard/api/getConsolidationEvolutionAdvanced';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const generateLastYears = (numYears) => {
  const currentYear = dayjs().year();
  return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
};

export const InadimplenciaConfiguracoesAvancadasEvolucao = ({ routeBack }) => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));
  const [listYearsHistorical, setListYearsHistorical] = useState([]);
  const [selectedYearHistorical, setSelectedYearHistorical] = useState(dayjs().year());

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    ...(daysDiff !== null && { days: daysDiff }),
  };

  const { data: summary, isError, refetch, isFetching, isFetched } = useConsolidationEvolutionAdvanced(filters);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{ cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Evolução da Inadimplência por aluno'} />
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        {summary && isFetched && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
              }}
            >
              <KpiComponent
                title={'Quantidade de alunos com boletos em aberto'}
                value={summary.evolution?.students_with_open_payments}
                tooltipText={'Verifica a quantidade de alunos que possuem pelo menos um boleto em aberto no ano atual.'}
                style={{ minWidth: '180px' }}
              />
              <KpiComponent
                title={'Quantidade de boletos vencidos'}
                value={summary.evolution?.payment_overdue_amount}
                tooltipText={'Verifica a quantidade de alunos que possuem pelo menos um boleto vencido no ano atual.'}
                style={{ minWidth: '180px' }}
              />
              <KpiComponent
                status={summary.media_desconto?.state}
                title={'Média de dias por atraso'}
                value={String(summary.evolution?.overdue_media.toFixed(2),)}
                tooltipText={'Média de dias em atraso dos boletos no ano atual.'}
                style={{ minWidth: '180px' }}
              />
            </Stack>
          </Stack>
        )}

        {isFetching && !summary && !summary?.evolution && <LoadingSummary />}

        <Box marginTop={'10px'} marginBottom={'20px'}>
          {/* <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('teste')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
          /> */}
        </Box>
        {summary?.student_history ? (
          <TableHeaderCustomEvolucao data={summary?.student_history || []} />
        ) : (
          <LoadingChart loading={!summary?.student_history} />
        )}
      </Box>
    </>
  );
};
